import { css } from "../../../styled-system/css";

export const styles = {
  section: () =>
    css({
      position: "relative",
      paddingBottom: "baseUnit.mobile4",
      width: "100%",
      "--scroll-gap": "token(spacing.baseUnit.mobile3)",
      desktop: {
        "--scroll-gap": "token(spacing.baseUnit.mobile4)",
      },
    }),
};
